import { render, staticRenderFns } from "./microbialLoadInSemenSample.vue?vue&type=template&id=0d57db05&scoped=true&"
import script from "./microbialLoadInSemenSample.vue?vue&type=script&lang=js&"
export * from "./microbialLoadInSemenSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d57db05",
  null
  
)

export default component.exports